import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import { DatepickerOptions } from 'ng2-datepicker';
import * as enLocale from 'date-fns/locale/en';

import {ToasterService} from "../../_services/toaster.service";
import {AuthenicationService} from "../../_services/authenication.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {DoctorService} from "../../_services/doctor.service";
import {PatientsService} from "../../_services/patients.service";
import {PaymentService} from "../../_services/payment.service";

declare var $: any;
declare var Razorpay: any;
import * as moment from "moment";
import {PricesService} from "../../_services/prices.service";

@Component({
  selector: 'app-create-payment-link',
  templateUrl: './create-payment-link.component.html',
  styleUrls: ['./create-payment-link.component.css']
})
export class CreatePaymentLinkComponent implements OnInit {

  options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    displayFormat: 'MMM D[,] YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 1, // 0 - Sunday, 1 - Monday
    locale: enLocale,
    // minDate: new Date(Date.now()), // Minimal selectable date
    maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {['z-index']:'1',['width']:'100%'}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };

  bookAppointmentForm: FormGroup;
  submitted = false;
  userdetaild: string;
  originalprice: any;
  returnUrl: string;
  mode: string = 'f2f';
  showHideForm = true;
  showPrice = false;
  discounted_price: any;
  displayDiv = 'block';
  modeList: any[] = ['Phone','Video'];
  schedules: any;
  schedulesFinal: any;
  modeFinal: any;
  pricemode: any;
  priceddata: any;
  doctors: [];
  doctorss: [];
  price: any;
  docid: string = '';
  discount_price: any = '';
  showHide: Boolean = false;
  today: string;
  username: string;
  users_email: string;
  users_mobile: string;
  scheduleFor: string;
  remainingData: any[] = [];

  dob: string;
  relation: string;
  parent_name: string;
  parent_email: string;
  parent_phone: string;

  predate: string;
  preid: string;
  isdisplaypre: Boolean = false;
  isdisplaymsg: Boolean = false;
  avavility: any[] = [];
  isdisplay: Boolean = true;
  ischecked: Boolean = true;
  pretime: string;
  userid: any;
  patients: any;
  troubles: string;

  todayTime: string;
  todayDateTime: string;
  sessions: any[] = [];
  sid: string;
  coupon_code: any = '';
  type = 'Appointment';
  user_email: any;
  next_free_session_or_event: any = '0';
  remaining: any = '0';
  total_session_remaining: any = '0';
  scheduleList: any[] = [];

  sids: any[] = [];
  morethenone_session_remaining: any[] = [];
  showhide: Boolean = false;
  promoCodeList: any;
  moreThenOne: any;
  moreValue: any;
  remainingGiftData: any;
  remainingGiftTotal: any = 0;
  consultMode: string;

  sgst: any;
  cgst: any;
  tot_sgst: any;
  tot_cgst: any;
  tot_payment: any;
  totalPayable_price: any;
  dtype: string;
  dexperience: string;
  dpricemode: string;


  couponForm: FormGroup;
  msg: any;
  isused: any;
  totalSessionWithThisDoctor: any;

  optionsPayment(price,name,email,contact,notes,type){
    return this.paymentservice.options(price,name,email,contact,notes,type);
  }


  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService,private spinnerService: Ng4LoadingSpinnerService, private doctorservice: DoctorService,private patientsService: PatientsService, private pricesService: PricesService, private paymentservice: PaymentService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }
    this.today = moment(new Date()).format("YYYY-MM-DD");
    this.todayTime = moment(new Date()).format("HH:mm");
    this.todayDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm");
    this.userid = this.route.snapshot.params.id;

    let newMode = localStorage.getItem('mode');
    let setmode = (newMode == null) ? 'Phone' : newMode

    let podtData = {status: true};
    this.doctorsList(podtData);
    this.getPatientById();



    this.bookAppointmentForm = this.formBuilder.group({
      doctors: ['', [Validators.required]],
      slot: ['', [Validators.required]],
      date: ['', ''],
      name: [{value: '', disabled: true}, [Validators.required]],
      email: [{value: '', disabled: true}, [Validators.required]],
      troubles: ['', [Validators.required]],
      mode: [setmode, [Validators.required]],
      dob: ['', [Validators.required]],
      relation: [''],
      parent_name: [''],
      parent_phone: [''],
    });

    this.consultMode = (this.bookAppointmentForm.controls.mode.value == 'video') ? 'Video' : this.bookAppointmentForm.controls.mode.value;

    this.couponForm = this.formBuilder.group({
      code: ['MP80', [Validators.required]]
    });


    const self = this;
    var date = new Date();
    date.setDate(date.getDate());
    $('.datepicker').datepicker({
      format: 'yyyy-mm-dd',
      todayHighlight: true,
      orientation: "auto",
      startDate: date,
      clearBtn: true
      // tslint:disable-next-line:only-arrow-functions
    }).on('changeDate', function (e) {
      self.onchangedate(e.format());
      $(this).datepicker('hide');
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }



  getPatientById() {
    this.patientsService.getPatientById(this.userid)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);


            this.patients = data.patientList;
            this.username = this.patients.patientid.users_name;
            this.users_email = this.patients.patientid.users_email;
            this.users_mobile = this.patients.patientid.users_mobile;

            const payload = {
              user_email: this.users_email
            };
            const payload1 = {
              receiver_email: this.users_email
            };
            this.getRemainingPackageSessions(payload);
            this.checkRemainingGiftSession(payload1);

            const sessionpayload = {
              clientid: this.userid
            };
             this.getPatientSessions(sessionpayload);
            this.bookAppointmentForm.setValue({
              name: this.patients.patientid.users_name,
              email: this.patients.patientid.users_email,
              doctors:'',
              mode:'Phone',
              slot:'',
              date: '',
              troubles: '',
              dob: '',
              relation: '',
              parent_name: '',
              parent_phone: '',
            });

          } else {
            console.log('Patients', data.ResponseMessage);
          }
        },
        error => {
          console.log('Patients', error.error.ResponseMessage);
        });
  }

  doctorsById(id) {
    this.doctorservice.getDoctorById(id)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.doctorss = data.doctorsList[0];
            //console.log(data.doctorsList[0]['own_space']);
            if (this.mode == 'video'){
              this.pricemode = 'Video';
            }
            if (this.mode == 'f2f'){
              this.pricemode = 'F2F Without Venue';

            }

            this.dtype = data.doctorsList[0].mental_health_prof;
            this.dexperience = data.doctorsList[0].experience;
            this.dpricemode = this.pricemode;
            this.modeFinal = this.pricemode;

            this.getPriceByExperienceAndProfession(this.dtype, this.dexperience, this.dpricemode, this.docid, true);
            // this.getPriceByExperienceAndProfession(this.doctorss['mental_health_prof'],this.doctorss['experience'], this.pricemode, this.docid);

          } else {
            console.log('no data found');
          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }

  getPriceByExperienceAndProfession(type,experience,mode,docid,start) {
    const payload = {
      mental_health_type: type,
      experience: experience,
      price_for: mode,
      docid: docid,
    };
    this.pricesService.getPriceByExperienceId(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.priceddata = data.priceList[0];
            this.price = this.priceddata.original_price;
            // this.discounted_price = (this.priceddata.original_price);
            this.originalprice = this.priceddata.original_price;
            this.sgst = this.priceddata.sgst;
            this.cgst = this.priceddata.cgst;
            this.tot_sgst = this.priceddata.tot_sgst;
            this.tot_cgst = this.priceddata.tot_cgst;
           this.discounted_price = (this.priceddata.original_price);
           this.tot_payment = (this.priceddata.totalPayable);

           if (start == true) {
             this.onApply();
           }else{
             this.totalPayable_price = (this.priceddata.totalPayable);
           }

          } else {
            this.price = 0;
            this.discounted_price = 0;
            this.originalprice = 0;
            this.totalPayable_price = 0;
            this.tot_sgst = 0;
            this.tot_cgst = 0;
            console.log('no data found!!!');
          }

        },
        error => {
          this.price = 0;
          this.discounted_price = 0;
          this.originalprice = 0;
          this.totalPayable_price = 0;
          this.tot_sgst = 0;
          this.tot_cgst = 0;
          console.log('Doctor', error);
        });
  }

  async onChangeSlot(id) {
    this.ischecked = false;
    this.preid = id;
    const schedulepayload = {
      id: this.preid
    };
    await this.scheduleById(schedulepayload);

  }

  onchangedate(date) {
    if (this.docid == ''){
      this.toaster.showError('Appointment','Please Select Therapist first');
      return;
    }
    // console.log(date);
    this.bookAppointmentForm.controls.slot.setValue('');
    const payload = {
      docid: this.docid,
      date: date,
      today: this.today,
      time: this.todayTime,
      scheduleFor: 'All',
    };
    this.getDoctorAvalibilityByDateNew(payload);

  }



  getDob(e){
    if (e !== undefined && e !== ''){
      let selectedDate = moment(e).format("YYYY-MM-DD");

      const differenceInYears = moment(this.today).diff(selectedDate, 'years');
      //console.log(differenceInYears);
      if (differenceInYears < 18){
        this.showHide = true;
        this.bookAppointmentForm.controls['relation'].setValidators([Validators.required]);
        this.bookAppointmentForm.controls['parent_name'].setValidators([Validators.required]);
        this.bookAppointmentForm.controls['parent_phone'].setValidators([Validators.required]);
      }
      else {
        this.showHide = false;
        this.bookAppointmentForm.controls['relation'].setErrors(null);
        this.bookAppointmentForm.controls['parent_name'].setErrors(null);
        this.bookAppointmentForm.controls['parent_phone'].setErrors(null);

        this.bookAppointmentForm.controls['relation'].setValidators(null);
        this.bookAppointmentForm.controls['parent_name'].setValidators(null);
        this.bookAppointmentForm.controls['parent_phone'].setValidators(null);
      }
    }

  }

  doctorsAvavilityByDate(payload) {
    this.doctorservice.getDoctorAvavilityByDate(payload)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.avavility = data.avilibility;
            this.isdisplay = true;
            this.isdisplaymsg = false;
          } else {
            // alert(data.ResponseMessage);
            this.avavility = [];
            this.isdisplay = true;
            this.isdisplaymsg = true;
            console.log('no data found');
          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }

  getDoctorAvalibilityByDateNew(payload) {
    this.doctorservice.getDoctorAvalibilityByDateNew(payload)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.avavility = data.avilibility;
            this.isdisplay = true;
            this.isdisplaymsg = false;
          } else {
            this.avavility = [];
            this.isdisplay = true;
            this.isdisplaymsg = true;
            console.log('no data found');
          }

        },
        error => {
          this.avavility = [];
          this.isdisplay = true;
          this.isdisplaymsg = true;
          console.log('Doctor', error.error.ResponseMessage);
        });
  };

  doctorsList(data) {
    this.doctorservice.getDoctorsByStatus(data)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.doctors = data.doctorsList;

          } else {
            console.log('Doctor', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }

  selectionChanged(e){
    this.docid = e.target.value;
    this.doctorsById(this.docid)
  }

  get f() { return this.bookAppointmentForm.controls; }

  async onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.bookAppointmentForm.invalid) {
      return;
    }

    let payl = {ids: this.bookAppointmentForm.controls.slot.value.toString()};

    this.doctorservice.checkAppointmentBooked(payl)
      .subscribe(async (data: any) => {
          if (data && data.ResponseCode === '200') {
              await this.proceedToNext(this.bookAppointmentForm.controls);
          } else {
            this.toaster.showError('Session Booking','Session has been already booked by someone else');
          }
        },
        error => {
          this.toaster.showError('Session Booking',error);
        });

  }

  async proceedToNext(data) {
    let selectedDate = moment(data.dob.value).format("YYYY-MM-DD");
    const formdata = {
      docid: this.docid,
      mode: data.mode.value,
      sid: data.slot.value,
      desc: data.troubles.value.slice(0, 150),
      dob: selectedDate,
      relation: (data.relation.value) ? data.relation.value : '',
      parent_name: (data.parent_name.value) ? data.parent_name.value : '',
      parent_email: '',
      parent_phone: (data.parent_phone.value) ? data.parent_phone.value : '',

    };
    this.troubles = data.troubles.value;
    this.parent_name = data.parent_name.value;
    this.parent_phone = data.parent_phone.value;
    this.dob = selectedDate;
    this.relation = data.relation.value;
    this.parent_email = '';

    const schedulepayload = {
      id: formdata.sid
    };
    await this.finalScheduleById(schedulepayload);

    this.sids.push(formdata.sid);

    this.showHideForm = false;
    this.showPrice = true;
    this.displayDiv = 'none';
    // console.log(formdata);
  }


  bookAppointment(payload) {
    this.patientsService.processNewFreeAppointment(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //alert(data.ResponseMessage);
            this.router.navigate([`/appointments-list/active`]);
          } else {
            alert(data.ResponseMessage);
            //this.toaster.showError('Add Patient', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          alert(error.error.ResponseMessage);
          //this.toaster.showError('Add Patient', error.error.ResponseMessage);
        });
  }

  async scheduleById(id) {
    this.patientsService.getScheduleById(id)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.schedules = data.avilibility[0];
            // if (this.schedules['location'] == 'Video'){
            //   this.modeList.push(this.schedules['location']);
            // }
            // else if (this.schedules['location'] == 'Phone'){
            //   this.modeList.push(this.schedules['location']);
            // }else{
            //   this.modeList.push('f2f');
            // }
            //console.log(data.avilibility[0]);
          } else {
            console.log('no data found');
            return false;
          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
          return false;
        });
  }

  async finalScheduleById(id) {
    this.patientsService.getScheduleById(id)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.schedulesFinal = data.avilibility[0];
            // if (this.schedulesFinal['location'] == 'Video'){
            //   this.modeFinal = this.schedules['location'];
            // }
            // else if (this.schedulesFinal['location'] == 'Phone'){
            //   this.modeFinal =  this.schedules['location'];
            // }else{
            //   this.modeFinal = 'f2f';
            // }
            // console.log(this.schedulesFinal);
          } else {
            console.log('no data found');
            return false;
          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
          return false;
        });
  }

  getPatientSessions(payload) {
    this.patientsService.getUserAppointment(payload)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.sessions = data.ClientAppointment;
            let troubles = '';
            if (this.sessions.length > 0){
              let total = (this.sessions.length - 1);
              this.dob = (this.sessions[total].dob)?this.sessions[total].dob:'';
              troubles = this.sessions[total].troubles;
              //console.log('this.dob',this.sessions[total]);
            }
            let dobb = (this.dob)?moment(this.dob).format("MMM D[,] YYYY"):'';
            this.bookAppointmentForm.controls.dob.setValue(dobb);
            this.bookAppointmentForm.controls.troubles.setValue(troubles);

            // console.log(this.sessions);
          } else {

          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }


  onApply(promoCode: string = ''){

    let code = '';

    if(promoCode == ''){
      this.submitted = true;

      // stop here if form is invalid
      if (this.couponForm.invalid) {
        return;
      }

      code = this.couponForm.controls.code.value.toUpperCase();
    }else{
      code = promoCode.toUpperCase();
    }

    if(code !== ''){

        this.getPromocodeByType(code);
    }

  }

  onCancle(){
    this.couponForm.controls.code.enable();
    // this.discounted_price = (this.price);
    this.getPriceByExperienceAndProfession(this.dtype, this.dexperience, this.dpricemode, this.docid, false);

    this.coupon_code = '';
    this.type = '';
    this.user_email = '';
    this.next_free_session_or_event = '0';
    this.remaining = '0';
    this.total_session_remaining = '0';
    this.morethenone_session_remaining = [];
    this.showhide = false;
    this.couponForm.reset();
  }


  getPromocodeByType(code){
    const payload = {
      type: 'Appointment',
      promocode: code,
      mode: this.modeFinal,
      docid: this.docid,
      user_email: this.users_email,
    };

    this.patientsService.getPromoCodeByCodeAndType(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            if(data.promoCodeList != false){
              let total = this.sids.length;


              if (data.promoCodeList.moreThenOne == true) {

                // console.log(total);
                if ((data.promoCodeList.total_remaining+1) < ((total == 0)?total+1:total)) {
                  alert(`You are having only ${data.promoCodeList.total_remaining+1} remaining sessions`);
                  this.onCancle();
                  return;
                }
              }

              this.couponForm.controls.code.disable();
              this.promoCodeList = data.promoCodeList;
              this.msg = this.promoCodeList.description;
              this.isused = this.promoCodeList.isUsed;
              this.user_email = this.userdetaild['users_email'];
              this.type = this.promoCodeList.type;
              this.next_free_session_or_event = this.promoCodeList.nextfree;
              let balance = (this.promoCodeList.total_remaining > 0)?(this.promoCodeList.total_remaining + 1):0;
              let real_balance = (this.promoCodeList.total_remaining > 0)?(this.promoCodeList.total_remaining):0;
              this.total_session_remaining =  (balance > 0)?(balance - ((total == 0)?total+1:total)):0;
              this.moreThenOne = (this.promoCodeList.moreThenOne)?this.promoCodeList.moreThenOne:false;
              this.moreValue = (this.promoCodeList.moreValue)?this.promoCodeList.moreValue:'0';
              // console.log(balance);
              if (this.promoCodeList.remaining > 0){
                this.remaining = (this.promoCodeList.remaining - 1);
              }
              else{
                this.remaining = data.remaining;
              }

              if (this.promoCodeList.discountType === 'Percentage'){
                if (this.moreThenOne == true) {
                    this.discounted_price = (this.promoCodeList.price );

                    this.tot_payment = (this.promoCodeList.payable);
                    this.totalPayable_price = (this.promoCodeList.payable );
                    this.tot_sgst = (this.promoCodeList.tot_sgst );
                    this.tot_cgst = (this.promoCodeList.tot_cgst );



                    for (let i = 0; i < ((total == 0)?total+1:total); i++) {

                        let bal = (real_balance - i);

                        this.morethenone_session_remaining.push(bal);
                    }
                    // console.log(this.morethenone_session_remaining);
                } else {
                  this.discounted_price = (this.promoCodeList.price * ((total == 0)?total+1:total));
                  this.totalPayable_price = (this.promoCodeList.payable * ((total == 0)?total+1:total));
                  this.tot_sgst = (this.promoCodeList.tot_sgst );
                  this.tot_cgst = (this.promoCodeList.tot_cgst );
                }
                this.coupon_code = code;
                this.showhide = true;


              }
              if (this.promoCodeList.discountType === 'Flat'){

                if (this.moreThenOne == true) {

                    this.discounted_price = (this.promoCodeList.price );
                    this.totalPayable_price = (this.promoCodeList.payable );
                    this.tot_sgst = (this.promoCodeList.tot_sgst );
                    this.tot_cgst = (this.promoCodeList.tot_cgst );
                    for (let i = 0; i < ((total == 0)?total+1:total); i++) {

                        let bal = (real_balance - i);

                        this.morethenone_session_remaining.push(bal);
                    }
                    // console.log(this.morethenone_session_remaining);
                } else {

                  this.discounted_price = (this.promoCodeList.price * ((total == 0)?total+1:total));
                  this.totalPayable_price = (this.promoCodeList.payable * ((total == 0)?total+1:total));
                  this.tot_sgst = (this.promoCodeList.tot_sgst );
                  this.tot_cgst = (this.promoCodeList.tot_cgst );
                  //
                }
                this.coupon_code = code;
                this.showhide = true;

              }
              if (this.promoCodeList.discountType === 'Next Free'){
                if (this.isused == 'Yes') {
                  if (this.promoCodeList.remaining > 0) {
                    this.discounted_price = (this.promoCodeList.price * ((total == 0)?total+1:total));
                    this.totalPayable_price = (this.promoCodeList.payable * ((total == 0)?total+1:total));
                    this.tot_sgst = (this.promoCodeList.tot_sgst );
                    this.tot_cgst = (this.promoCodeList.tot_cgst );
                    this.msg = 'This is Your Free session';
                  } else {
                    alert('Already Availed this offer');
                    this.couponForm.reset();
                    this.showhide = false;
                  }

                } else {
                  this.discounted_price = (this.price * ((total == 0)?total+1:total));
                  this.totalPayable_price = (this.promoCodeList.payable * ((total == 0)?total+1:total));
                  this.tot_sgst = (this.promoCodeList.tot_sgst );
                  this.tot_cgst = (this.promoCodeList.tot_cgst );
                }
              }
            }else{
              alert('PromoCode Already Used');
            }


          } else {
            alert(data.ResponseMessage);
            this.couponForm.reset();
            this.showhide = false;
          }

        },
        error => {
          //console.log(error);
          alert(error);
          this.couponForm.reset();
          this.showhide = false;
        });
  }


  getUserSingleDoctorAppointment(payload) {
    this.patientsService.getUserSingleDoctorAppointment(payload)
      .subscribe(
        (data: any) => {
          // console.log(data);
          if (data && data.ResponseCode === '200') {
            this.totalSessionWithThisDoctor = data.DoctorAppointment.length;
            if (this.totalSessionWithThisDoctor > 0) {
                this.scheduleFor = 'All';
            }else{
              this.scheduleFor = 'New';
            }

          } else {
            this.scheduleFor = 'New';
            console.log('Doctor', data.ResponseMessage);
          }

        },
        error => {
          this.scheduleFor = 'New'
          console.log('Doctor', error.ResponseMessage);
        });
  }


  async onSubmit1(){

    let payl = {ids: this.sids.toString()};

    this.doctorservice.checkAppointmentBooked(payl)
      .subscribe(async (data: any) => {
          if (data && data.ResponseCode === '200') {
              await this.proceedToCheckout();
          } else {
            this.toaster.showError('Session Booking','Session has been already booked by someone else');
          }
        },
        error => {
          this.toaster.showError('Session Booking',error);
        });
  }


  checkRemainingSession(payload) {
    this.patientsService.checkRemainingSession(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let total = data.Data.length;
            this.remainingData = data.Data[total - 1];
            //console.log(this.remainingData);
          }
          else{
            console.log('check',data.ResponseMessage);
          }

        },
        error => {
          console.log('check',error);
        });
  }

  getRemainingPackageSessions(payload) {
    this.patientsService.getRemainingPackageSessions(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // let total = data.Data.length;
            // this.remainingData = data.Data[total - 1];
            //console.log(this.remainingData);
            this.remainingData = data.Data;
          }
          else{
            console.log('check',data.ResponseMessage);
          }

        },
        error => {
          console.log('check',error);
        });
  }

  checkRemainingGiftSession(payload) {
    this.patientsService.getUserGiftCodeByEmail(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let remainingData = data.promoCodeList;
            let total = 0;
            for (let item of remainingData) {
                total += item.remainingSession;
            }
            this.remainingGiftTotal = total;
            this.remainingGiftData = remainingData;
          }
          else{
            console.log('check',data.ResponseMessage);
          }

        },
        error => {
          console.log('check',error);
        });
  }

  async proceedToCheckout() {
    if (this.coupon_code != ''){
      this.discount_price = this.discounted_price.toString();
      this.totalPayable_price = this.totalPayable_price.toString();
    }

    let amount;
    if (this.discount_price == ''){
      // amount = Number((this.price)*100).toFixed();
      amount = Number((this.totalPayable_price * this.sid.length) * 100).toFixed();
    }else{
      // amount = Number(this.discount_price*100).toFixed();
      amount = Number(this.totalPayable_price * 100).toFixed();
    }

    let parentData = this.dob.toString() + ',' + this.relation + ',' + this.parent_name + ',' + this.parent_email + ',' + this.parent_phone.toString();
    let details = this.troubles;

    const notesData = {
      docid: this.docid,
      clientid: this.userid,
      original_price: this.price,
      discount_price: this.totalPayable_price,
      coupon_code: this.coupon_code,
      //appointmentMode: this.mode,
      appointmentMode: this.consultMode,
      parentData: parentData,
      scheduleId: this.sids.toString(),
      troubles: details,
      amount:amount,
      user_email: this.users_email,
      type: 'Appointment',
      next_free_session_or_event: (this.next_free_session_or_event)?this.next_free_session_or_event.toString():"0",
      total_session_remaining: (this.morethenone_session_remaining.length > 0)?this.morethenone_session_remaining.toString():"0",
      remaining: (this.remaining)?this.remaining.toString():'0'
    };
    // console.log(notesData);return;



    if (amount > 0){
      // alert('Plan expired');
      // for (let i = 0; i < (this.sids.length+1); i++) {
      //   const notesData1 = {
      //     docid: this.docid,
      //     clientid: this.usersid,
      //     original_price: this.price,
      //     discount_price: this.discount_price,
      //     coupon_code: this.coupon_code,
      //     scheduleDate: (this.scheduleList[i]['date'])?this.scheduleList[i]['date']:'',
      //     scheduletime: (this.scheduleList[i]['start_time'])?this.scheduleList[i]['start_time']:'',
      //     appointmentMode: this.modeList.toString(),
      //     dob: this.dob.toString(),
      //     relation: this.relation.toString(),
      //     parent_name: this.parent_name.toString(),
      //     parent_email: this.parent_email.toString(),
      //     parent_phone: this.parent_phone.toString(),
      //     scheduleId: this.sids[i],
      //     troubles: details,
      //     type: 'Appointment',
      //     next_free_session_or_event: (this.next_free_session_or_event)?this.next_free_session_or_event.toString():"0",
      //     total_session_remaining: (this.morethenone_session_remaining.length > 0)?this.morethenone_session_remaining[i]:"0",
      //     remaining: (this.remaining)?this.remaining.toString():"0"
      //   };
      //   this.addTempAppointment(notesData1);
      // }
      //
      //
      //
      //
      let options = this.optionsPayment(amount,this.username,this.users_email,this.users_mobile,notesData,'appointment');

      var rzp1 = new Razorpay(options);
      rzp1.open();

    }
    else{
      this.bookAppointment(notesData);
    }
  }

  changeMode(mode){
    localStorage.setItem('mode', mode);
    let newMode = localStorage.getItem('mode');

    this.consultMode = mode;
  };

}
